import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { userApi } from 'src/Services/API';
import { UpdateUserDto, UserWithPrivateInfoDto } from 'src/Services/API/generated';

export const useUpdateUser = (
  options?: UseMutationOptions<UserWithPrivateInfoDto, unknown, UpdateUserDto>
) => {
  const queryClient = useQueryClient();
  return useMutation<UserWithPrivateInfoDto, unknown, UpdateUserDto>(
    'update-user',
    async data => {
      const response = await userApi.userControllerUpdateUser(data);
      return response.data;
    },
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        queryClient.setQueryData(['fetch-user'], data);

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
